import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Icon, Tooltip, Button, Popconfirm } from 'antd'
import moment from 'moment'

@inject((store: any) => {
    const { termsStore, termCollectionsStore, popupStore } = store
    return { termsStore, termCollectionsStore, popupStore }
})
@observer
class Term extends Component<any, any> {
    handleEditTerm = item => {
        const collection_id = this.props.match.params.id
        this.props.popupStore.togglePopup('editTerm', { ...item, collection_id })
    }
    handleToggleTerm = term => {
        const collection_id = this.props.match.params.id
        const term_id = term.id
        this.props.termCollectionsStore.updateList({ collection_id, term_id })
        this.props.termsStore.toggleEdit(term)
    }
    handleEditTermCollection = term => {
        this.props.termCollectionsStore.toggleEdit(term)
        this.props.popupStore.togglePopup('termCollection')
    }
    handleAddTermCollection = term => {
        this.props.termCollectionsStore.toggleEdit(term)
        this.props.popupStore.togglePopup('addTermCollection')
    }
    handleRemoveTerm = () => {
        const { match, termsStore, termCollectionsStore } = this.props
        const collection_id = match.params.id
        termsStore.deleteFromCollection(
            collection_id,
            termCollectionsStore.list.map(term => term.policy_id)
        )
        termsStore.resetEdit()
    }
    render() {
        const { item, termsStore, termCollectionsStore } = this.props
        return (
            <div
                style={{
                    borderBottom: '1px dotted gray',
                    backgroundColor: `${termsStore.editTerm.id === item.id ? '#f0f2f5' : 'white'}`
                }}
            >
                <div
                    style={{
                        width: '100%',
                        cursor: 'pointer',
                        padding: '1rem',
                        fontSize: '1rem',
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'row'
                    }}
                    onClick={() => this.handleToggleTerm(item)}
                >
                    <div>
                        {termsStore.editTerm.id === item.id ? <Icon type="down" /> : <Icon type="left" />}
                        <strong>
                            {item['id']} | {item['title']}
                        </strong>
                    </div>
                    <div>
                        {item['updated_by']} | {moment(item['updated_at']).format('DD/MM/YYYY HH:mm')}
                    </div>
                </div>
                {termsStore.editTerm.id === item.id ? (
                    <div style={{ width: '100%', padding: '0 1rem 2rem 1rem' }}>
                        <div style={{ backgroundColor: 'white', padding: '1rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <label style={{ margin: '0', fontSize: '1.1rem' }}>
                                    <strong>תיאור התנאי</strong>
                                </label>
                                <Button style={{ marginLeft: '0' }} onClick={() => this.handleEditTerm(item)}>
                                    <Icon type="edit" /> עריכת תוכן התנאי
                                </Button>
                            </div>
                            {item['description'] ? (
                                <div
                                    style={{ marginTop: '1rem' }}
                                    className="text-box"
                                    dangerouslySetInnerHTML={{ __html: item['description'] }}
                                />
                            ) : (
                                <div>-- אין תיאור</div>
                            )}
                            <label style={{ margin: '1rem 0 0', fontSize: '1.1rem' }}>
                                <strong>הנחיות לקבלת התנאי</strong>
                            </label>
                            <div
                                style={{ marginTop: '1rem' }}
                                className="text-box"
                                dangerouslySetInnerHTML={{ __html: item['instruction'] }}
                            />
                        </div>
                        <div style={{ backgroundColor: 'white', padding: '1rem', marginTop: '1rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <label>
                                    <strong>פוליסות המקושרות לתנאי ולזכות זו</strong>
                                </label>
                                <a
                                    onClick={() =>
                                        this.handleAddTermCollection({
                                            term_id: item.id,
                                            collection_id: this.props.match.params.id
                                        })
                                    }
                                    style={{ textDecoration: 'underline', color: '#e77910' }}
                                >
                                    <strong>הוסף קישור לפוליסה+</strong>
                                </a>
                            </div>
                            <div>
                                {termCollectionsStore.list.length > 0 ? (
                                    termCollectionsStore.list.map((termCollection, index) => (
                                        <div
                                            style={{
                                                backgroundColor: '#f0f2f5',
                                                margin: '0.2rem 0',
                                                padding: '0.5rem 0.8rem',
                                                borderRadius: '0.3rem',
                                                display: 'flex',
                                                justifyContent: 'space-between'
                                            }}
                                            key={index}
                                        >
                                            <div>
                                                <strong>פוליסה:</strong>
                                                <Tooltip
                                                    placement="top"
                                                    overlayStyle={{ textAlign: 'center' }}
                                                    title={termCollection.name}
                                                >
                                                    <a
                                                        style={{ padding: '0 0.5rem', textDecoration: 'underline' }}
                                                        target="_blank"
                                                        href={`/insurance/${termCollection.company_id}/${termCollection.policy_id}`}
                                                    >
                                                        {termCollection.policy_id}
                                                    </a>
                                                </Tooltip>
                                                <span style={{ borderRight: '1px solid black', padding: '0 0.5rem' }}>
                                                    <strong>השתתפות עצמית:</strong>
                                                    {termCollection.deductible
                                                        ? termCollection.deductible
                                                        : 'אין נתונים'}
                                                </span>
                                                <span style={{ borderRight: '1px solid black', padding: '0 0.5rem' }}>
                                                    {termCollection.updated_by ? termCollection.updated_by : 'מערכת'}
                                                </span>
                                            </div>
                                            <div>
                                                <a
                                                    style={{ padding: '0 0.3rem' }}
                                                    onClick={() => this.handleEditTermCollection(termCollection)}
                                                >
                                                    <Icon type="form" />
                                                    <span style={{ padding: '0 0.2rem' }}>ערוך</span>
                                                </a>
                                                <Popconfirm
                                                    placement="topLeft"
                                                    title={'האם ברצונך להסיר את הקישור לפוליסה?'}
                                                    onConfirm={() => termCollectionsStore.delete(termCollection)}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <a style={{ padding: '0 0.3rem' }}>
                                                        <Icon type="delete" />
                                                        <span style={{ padding: '0 0.2rem' }}>הסר קישור</span>
                                                    </a>
                                                </Popconfirm>
                                            </div>
                                        </div>
                                    ))
                                ) : !termCollectionsStore.loading ? (
                                    <div
                                        style={{
                                            backgroundColor: '#b93333',
                                            textAlign: 'center',
                                            padding: '0.5rem 1.2rem',
                                            color: 'white',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        לתשומת ליבך! ללא קישור לפוליסה לא יישמר הקישור בין התנאי לזכות
                                    </div>
                                ) : (
                                    'טוען...'
                                )}
                            </div>
                        </div>
                        <div
                            style={{ justifyContent: 'flex-end', alignItems: 'center', display: 'flex', width: '100%' }}
                        >
                            <Popconfirm
                                title="האם אתה רוצה להסיר את הקישור של התנאי והפוליסות מזכות זו?"
                                okText="הסר קישור בין תנאי ופוליסות"
                                cancelText="ביטול"
                                onConfirm={() => this.handleRemoveTerm()}
                            >
                                <Button style={{ marginTop: '1rem' }}>
                                    <Icon type="disconnect" /> הסר קישור של תנאי זה מהזכות
                                </Button>
                            </Popconfirm>
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </div>
        )
    }
}

export default withRouter(Term)
